import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { COLORS } from '../../../utils/Application_Constants';
import { ExpenseStatusChipStyles } from './ExpenseStatus.enum';

const useStyles = makeStyles(() => ({
    status: {
        width: 12,
        height: 12,
        borderRadius: 100,
        borderWidth: 1,
        borderStyle: 'solid',
        background: COLORS.LT_MIDNIGHT10,
        borderColor: COLORS.LT_MIDNIGHT50,
    },
    optionPrimary: {
        background: COLORS.LT_JOURNEY10,
        borderColor: COLORS.LT_JOURNEY,
    },
    optionSuccess: {
        background: COLORS.LT_EMERALD10,
        borderColor: COLORS.LT_EMERALD,
    },
    optionError: {
        background: COLORS.LT_PEPPER10,
        borderColor: COLORS.LT_PEPPER,
    },
    optionWarning: {
        background: COLORS.LT_SUNFLOWER10,
        borderColor: '#AD7829',
    },
    ...ExpenseStatusChipStyles,
}));

const StatusOption = (props) => {
    const { status, label } = props;
    const classes = useStyles();
    return (
        <Box display="flex" gap={2} alignItems="center">
            <div className={`${classes.status} ${classes[`chip${status}`]}`} />
            <div>{label}</div>
        </Box>
    );
};

export default withTranslation()(StatusOption);
